/**
 * Helpers.
 */
class IconicHelpers {
	/**
	 * Get class name without prefix.
	 */
	static getUsableClassName = ( className, append = '' ) => {
		return className.replace( '.', '' ) + append;
	};

	/**
	 * Get cookie.
	 *
	 * @param cname
	 * @returns {string|boolean}
	 */
	static getCookie = ( cname ) => {
		let name = cname + "=";
		let decodedCookie = decodeURIComponent( document.cookie );
		let ca = decodedCookie.split( ';' );

		for ( let i = 0; i < ca.length; i ++ ) {
			let c = ca[ i ];
			while ( c.charAt( 0 ) === ' ' ) {
				c = c.substring( 1 );
			}
			if ( c.indexOf( name ) === 0 ) {
				return c.substring( name.length, c.length );
			}
		}

		return false;
	}
}

export {IconicHelpers};